module.exports = __webpack_public_path__ + "img/office-icon.2091cd8b.svg";